// Toast copy helpers for the Institution Import success flow.
// Extracted from InstitutionImportModal so that file stays under the
// component size gate.

// Currency symbols we render inline. Anything not listed here falls back
// to the ISO code so we never invent a symbol for an obscure currency.
const _CURRENCY_SYMBOLS = {
  GBP: '\u00A3', USD: '$', EUR: '\u20AC', NGN: '\u20A6', ZAR: 'R',
  KES: 'KSh', GHS: 'GH\u20B5', AED: 'AED', SGD: 'S$', CAD: 'C$',
  AUD: 'A$', CHF: 'CHF', HKD: 'HK$', JPY: '\u00A5', CNY: '\u00A5',
  INR: '\u20B9',
};

const _formatMoney = (code, amount) => {
  const symbol = _CURRENCY_SYMBOLS[code] || `${code} `;
  return `${symbol}${amount.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const _formatTotals = (totals) => {
  const entries = Object.entries(totals || {}).filter(([, v]) => v > 0);
  if (entries.length === 0) return '';
  // Biggest currency reads first so it dominates the sentence.
  entries.sort((a, b) => b[1] - a[1]);
  const parts = entries.map(([code, amount]) => _formatMoney(code, amount));
  if (parts.length === 1) return ` worth ${parts[0]}`;
  return ` worth ${parts.slice(0, -1).join(' + ')} + ${parts[parts.length - 1]}`;
};

const _shortName = (n) => {
  const s = (n || '').trim();
  return s.length > 24 ? `${s.slice(0, 22)}\u2026` : s;
};

const _joinNames = (names) => {
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

// Build the personal success toast copy from a commit response, e.g.
// "Added Vodafone, GSK and HSBC worth £5,700 to your Portfolio Investments."
export const buildSuccessToast = (body, targetLabel) => {
  const names = (body.created_names || []).map(_shortName).filter(Boolean);
  const count = body.created_count || 0;
  const worth = _formatTotals(body.totals_by_currency);
  if (!names.length) {
    return body.message || `Added ${count}${worth} to your ${targetLabel}.`;
  }
  const shown = names.slice(0, 3);
  const extra = count - shown.length;
  const list = extra > 0
    ? `${shown.join(', ')} and ${extra} more`
    : _joinNames(shown);
  return `Added ${list}${worth} to your ${targetLabel}.`;
};
